import { type AxiosResponse } from 'axios'
import { notification } from '../../../components/Notifications'

type SetTaskFn = (taskId: string, message: string, successMessage?: string, onComplete?: () => void) => void

interface UpdateTemplateRevisionSuccessDeps {
  setTask: SetTaskFn
  refreshSections: () => void
}

// Both surfaces (per-section row action + project-wide topbar action) hit the same body-keyed
// endpoint and return 202. On 202 we register the page-lock task; a synchronous (200/201)
// response is tolerated as a fallback while the backend conversion is in flight.
export const createUpdateTemplateRevisionSuccessHandler = ({ setTask, refreshSections }: UpdateTemplateRevisionSuccessDeps) =>
  (data: Pick<AxiosResponse, 'status' | 'data'>): void => {
    if (data?.status === 202) {
      const { taskId, message } = data?.data ?? {}
      if (taskId) {
        setTask(
          taskId,
          message ?? 'Updating survey template revision...',
          'Survey template revision updated successfully.',
          refreshSections
        )
        notification('Updating survey template revision', {
          variant: 'info',
          subTitle: 'Your changes are being applied in the background.'
        })
      }
      return
    }

    notification(data?.data?.message ?? 'Survey template revision updated successfully', { variant: 'success' })
    refreshSections()
  }
